module.exports = __webpack_public_path__ + "img/ficus_transparente.d39157d.png";